import Collection from "./Collection";
import Item from "./Item";

export default {
  Collection,
  Item,
};
